import { transparentize } from 'polished';
import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { Colors } from '.';
import { LFC } from '../Legacy';

const Track = styled.div<{ color: string }>`
    position: relative;
    height: .375rem;
    background: ${p => transparentize(.75, p.color)};
    border-radius: 1rem;
`;

const Bar = styled.div<{ color: string }>`
    position: absolute;
    top: 0;
    left: 0;
    width: 0%;
    max-width: 100%;
    height: 100%;
    border-radius: 1rem;
    background: ${p => p.color};
    transition: width 100ms ease-out;
`;

const Base: LFC<{ color?: string, progress?: number, etc?: number }> = ({ color, progress, etc }) => {

    const bar = useRef<HTMLDivElement>();
    const width = `${Math.round((progress || 0) * 100)}%`;

    useEffect(() => {
        if (!etc) return;
        const a = bar.current.animate([
            { width },
            { width: '100%' },
        ], {
            duration: etc,
            fill: 'forwards',
        });
        return () => a.cancel();
    }, [etc]);

    return <Track color={color ?? Colors.primaryText}>
        <Bar ref={bar} color={color ?? Colors.primaryText} style={{ width }} />
    </Track>;
};

export const LoadingBar = Object.assign(Base, { Track, Bar });

export const LoadingBarTimeout = ({ timeoutMs, onTimeout }: { timeoutMs: number, onTimeout: () => void }) => {

    const [done, setDone] = useState(false);

    useEffect(() => {
        const t = setTimeout(() => {
            setDone(true);
            onTimeout();
        }, timeoutMs);
        return () => clearTimeout(t);
    }, [timeoutMs, onTimeout]);

    return <LoadingBar progress={done ? 0 : 1} etc={timeoutMs} />;
};
